import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuthRequest } from "request/request";

export const getCoursesInfoReport = createAsyncThunk(
  "reports/getCoursesInfoReport",
  async (studType, { rejectWithValue }) => {
    try {
      let url = `education/v1/courses-info-report?stud_type_id=${studType}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesAgesInfoReport = createAsyncThunk(
  "reports/getCoursesAgesInfoReport",
  async ({ stud_type_id, edu_year_id }, { rejectWithValue }) => {
    try {
      let url = `education/v1/courses-ages-info-report?stud_type_id=${stud_type_id}&edu_year_id=${edu_year_id}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesInfoBySpecReport = createAsyncThunk(
  "reports/getCoursesInfoBySpecReport",
  async (report_number, { rejectWithValue }) => {
    try {
      let url = `education/v1/courses-info-by-spec-report?report_number=${report_number}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesInfoByRegionReport = createAsyncThunk(
  "reports/getCoursesInfoByRegionReport",
  async ({ reportType, currentStudentType }, { rejectWithValue }) => {
    try {
      let url = `education/v1/courses-info-by-country-report?report_number=${reportType}`;

      if (currentStudentType) {
        url += `&stud_type_id=${currentStudentType}`;
      }

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCollegeGraduatesReport = createAsyncThunk(
  "reports/getCollegeGraduatesReport",
  async ({ currentEduYear, currentStudentType }, { rejectWithValue }) => {
    try {
      let url = `education/v1/college-graduates?edu_year_id=${currentEduYear}`;

      if (currentStudentType) {
        url += `&stud_type_id=${currentStudentType}`;
      }

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCollegeDirectorsInfoReport = createAsyncThunk(
  "reports/getCollegeDirectorsInfoReport",
  async (_, { rejectWithValue }) => {
    try {
      let url = `staff/v1/directors-info`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCollegeCafedrasInfoReport = createAsyncThunk(
  "reports/getCollegeCafedrasInfoReport",
  async (_, { rejectWithValue }) => {
    try {
      let url = `staff/v1/cafedras-info`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAttendanceInSemester = createAsyncThunk(
  "reports/getAttendanceInSemester",
  async (currentStudentType, { rejectWithValue }) => {
    try {
      let url = `education/v1/get-courses-attendence-in-semesters?stud_type_id=${currentStudentType}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesByLanguage = createAsyncThunk(
  "reports/getCoursesByLanguage",
  async (currentStudentType, { rejectWithValue }) => {
    try {
      let url = `education/v1/graduate-courses-info-by-language-report?stud_type_id=${currentStudentType}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGraduateCoursesInfoByLanguage = createAsyncThunk(
  "reports/getGraduateCoursesInfoByLanguage",
  async (currentStudentType, { rejectWithValue }) => {
    try {
      let url = `/education/v1/graduate-courses-info-by-language-report?stud_type_id=${currentStudentType}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEducationQualityInSemesters = createAsyncThunk(
  "reports/getEducationQualityInSemesters",
  async (
    { currentEducationYear, currentSemester, currentStudentType },
    { rejectWithValue }
  ) => {
    try {
      let url = `/education/v1/education-quality-in-semesters?edu_year_id=${currentEducationYear}&semester_id=${currentSemester}`;

      if (currentStudentType) {
        url += `&stud_type_id=${currentStudentType}`;
      }

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getCoursesAttendenceInSemesters = createAsyncThunk(
  "reports/getCoursesAttendenceInSemesters",
  async ({ currentStudentType, currentSemester }, { rejectWithValue }) => {
    try {
      let url = `/education/v1/get-courses-attendence-in-semesters?stud_type_id=${currentStudentType}&summary_type=${currentSemester}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getGraduateCoursesBySpecReport = createAsyncThunk(
  "reports/getGraduateCoursesBySpecReport",
  async (currentStudentType, { rejectWithValue }) => {
    try {
      let url = `/education/v1/graduate-courses-by-spec-report?stud_type_id=${currentStudentType}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
